<template>
  <div class="d-flex flex-row gap-2 align-center">
    <slot>
      <span :id="titleId" :class="{ 'font-weight-medium': bold, 'font-size-14': small, 'text-muted': muted }">
        {{ text }}
      </span>
    </slot>
    <info-dialog-activator v-if="info || !!$scopedSlots.info" :info="info" v-slot="slot">
      <slot name="info" v-bind="slot" />
    </info-dialog-activator>
  </div>
</template>

<script>
import { PropsDefinition } from '@/_typedefs'
import InfoDialogActivator from '../InfoDialogs/InfoDialogActivator.vue'

/**
 * @typedef {Object} TitleProps
 * @property {boolean?} [bold]
 * @property {boolean?} [small]
 * @property {boolean?} [muted]
 * @property {string?} info
 */

export default {
  components: { InfoDialogActivator },
  name: 'TitleComponent',
  /** @type {PropsDefinition<TitleProps & {text: string}>} */
  props: {
    text: {
      type: String,
      default: null,
    },
    bold: {
      type: Boolean,
      default: true,
    },
    small: {
      type: Boolean,
      default: false,
    },
    muted: {
      type: Boolean,
      default: false,
    },
    info: {
      type: String,
      default: null,
    },
    titleId: {
      type: String,
    },
  },
}
</script>

<style scoped>
:deep(.v-btn--icon) {
  height: info-dialog-activator;
  width: 24px;
}
</style>
